module.exports = __webpack_public_path__ + "img/guy.79fcf270.svg";